import React, { useState } from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

// 悬浮返回按钮样式
const btnSize = 56;
const closedWidth = btnSize;
const openWidth = 200;
const padding = 18;

const FloatingBackButton: React.FC = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 40,
        right: 40,
        zIndex: 1001,
        width: open ? openWidth : closedWidth,
        height: btnSize,
        boxShadow: '0 4px 12px rgba(24, 144, 255, .35)',
        background: '#1890ff',
        borderRadius: btnSize / 2,
        transition: 'width 0.25s cubic-bezier(.08,.82,.17,1),box-shadow .25s',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        overflow: 'hidden',
        padding: `0 ${padding}px`,
        opacity: 0.96,
      }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      title="返回展示页"
    >
      <div
        style={{
          width: btnSize,
          height: btnSize,
          borderRadius: '50%',
          background: 'rgba(24,144,255,1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          fontSize: 28,
          transition: 'background .2s',
        }}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 5L4 12L11 19"/><line x1="4" y1="12" x2="20" y2="12"/></svg>
      </div>
      {/* 展开后显示文字和按钮 */}
      <div
        style={{
          maxWidth: open ? 110 : 0,
          opacity: open ? 1 : 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          color: 'white',
          fontSize: 16,
          fontWeight: 500,
          marginLeft: 8,
          transition: 'all 0.25s cubic-bezier(.08,.82,.17,1)',
          pointerEvents: open ? 'auto' : 'none',
        }}
      >
        返回展示页
      </div>
      {/* 全区域可点，兼容展示收缩时点击 */}
      <Button
        type="link"
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          opacity: 0, // 用作全区域点击而不可视
          cursor: 'pointer',
          zIndex: 9,
        }}
        tabIndex={-1}
        onClick={() => navigate('/show')}
      />
    </div>
  );
};

export default FloatingBackButton;

